import React, { useState } from "react";
import locale from "locale";
import { connect } from "react-redux";
import { Row, Col, Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { useHistory } from "react-router-dom";

import {
    getTemplates,
    previewTemplate as fetchPreviewTemplate,
    deleteTemplate,
    getGlobalSettings,
} from "../../../../api/cp";
import Breadcrumbs from "../../UI/Breadcrumbs";
import LetterTemplatePreview from "../../UI/HtmlPreview";
import LettersList from "./LettersList";

const activeCrumbs = ["mainMenu.emails", "mainMenu.emails.lettersConstructor"];

const LettersConstructor = ({ event, location }) => {
    const history = useHistory();

    const [templates, setTemplates] = useState([]);
    const [previewTemplate, setPreviewTemplate] = useState(null);
    const [settings, setSettings] = useState(null);

    React.useEffect(async () => {
        fetchTemplates();

        const data = await getGlobalSettings(event.eventPassword);
        setSettings(data);
    }, []);

    const isPreviewTemplateExist = () => Boolean(previewTemplate);

    async function fetchTemplates() {
        const data = await getTemplates(event.eventKey);
        setTemplates(data);
    }

    function onEditTemplate(template) {
        history.push(`${location.pathname}/${template.id}`);
    }

    async function onPreviewTemplate(template) {
        const preview = await fetchPreviewTemplate(template.id);
        setPreviewTemplate(preview);
    }

    async function onDeleteTemplate(template) {
        try {
            await deleteTemplate(template.id);
            fetchTemplates();
        } catch (error) {
            alert(error.message || "Delete template error");
        }
    }

    return (
        <section className="letters-constructor">
            <Breadcrumbs
                link={`/event/${event.eventPassword}`}
                activeCrumbs={activeCrumbs}
            />

            <Row>
                <Col lg={12}>
                    <LinkContainer
                        to={`${location.pathname}/create`}
                        style={{ float: "right" }}
                    >
                        <Button>{locale("email.createLetterTemplate")}</Button>
                    </LinkContainer>
                </Col>
            </Row>

            <LettersList
                templates={templates}
                onEdit={onEditTemplate}
                onPreview={onPreviewTemplate}
                onDelete={onDeleteTemplate}
            />

            {settings && (
                <LetterTemplatePreview
                    isModalVisible={isPreviewTemplateExist()}
                    template={previewTemplate}
                    onHide={() => setPreviewTemplate(null)}
                    background={settings.darkColor}
                />
            )}
        </section>
    );
};

const mapStateToProps = (store) => {
    return {
        event: store.currentEvent,
    };
};

export default connect(mapStateToProps)(LettersConstructor);
